import { Widget, Popover, PopupButton, Sidetab, SliderButton } from '@typeform/embed-react';
import useIsMobile from 'hooks/utils/useIsMobile';
import { useEffect, useRef } from 'react';
import { useTranslations } from 'contexts';
import styles from './typeForm.module.scss';

const TypeForm = ({ data }) => {
  const {
    typeFormId,
    formType,
    buttonText,
    buttonColor,
    buttonTextColor,
    heightDesktop,
    heightMobile,
    widthDesktop,
    widthMobile,
    anchorId,
  } = data;

  const translations = useTranslations();
  const defaultButtonColor = '#3c3c3b';
  const defaultButtonTextColor = '#f9f9f9';
  const isMobile = useIsMobile();
  const scriptLoaded = useRef(false);

  const buttonStyle = {
    padding: '1rem 2rem',
    borderRadius: '5rem',
    border: 'none',
    background: buttonColor?.color || defaultButtonColor,
    color: buttonTextColor?.color || defaultButtonTextColor,
    cursor: 'pointer',
    position: 'fixed',
    fontSize: '1.6rem',
    bottom: 20,
    right: 20,
    zIndex: 9999,
    boxShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
  };

  useEffect(() => {
    if (formType === 'Embeded' && typeFormId && !scriptLoaded.current) {
      // Only load the script once
      if (!document.querySelector('script[src*="embed.typeform.com/next/embed.js"]')) {
        const script = document.createElement('script');
        script.src = '//embed.typeform.com/next/embed.js';
        script.async = true;
        script.onload = () => {
          scriptLoaded.current = true;
        };
        document.body.appendChild(script);
      } else {
        // Script already exists, just reload embeds
        if (window.tf && window.tf.reload) {
          window.tf.reload();
        }
        scriptLoaded.current = true;
      }
    }
  }, [formType, typeFormId]);

  if (!typeFormId) return null;

  return (
    <>
      {formType === 'Embeded' && <div data-tf-live={typeFormId} />}
      {formType === 'Inline' && (
        <section className={styles.container} id={anchorId}>
          <div
            style={{
              width: isMobile ? `${widthMobile || 100}%` : `${widthDesktop || 100}%` || 'auto',
            }}
          >
            <Widget
              id={typeFormId}
              inlineOnMobile
              style={{
                height: isMobile ? heightMobile || 500 : heightDesktop || 600,
              }}
            />
          </div>
        </section>
      )}
      {formType === 'Side tab' && (
        <Sidetab
          id={typeFormId}
          hidden={{ foo: 'foo value', bar: 'bar value' }}
          buttonText={buttonText}
          buttonColor={buttonColor?.color || defaultButtonColor}
          buttonTextColor={buttonTextColor?.color || defaultButtonTextColor}
        />
      )}

      {formType === 'Slider' && (
        <SliderButton id={typeFormId} buttonText={buttonText} style={buttonStyle}>
          {buttonText}
        </SliderButton>
      )}

      {formType === 'Popup' && (
        <PopupButton id={typeFormId} position="right" style={buttonStyle}>
          {buttonText}
        </PopupButton>
      )}

      {formType === 'Popover' && (
        <Popover
          id={typeFormId}
          tooltip={buttonText}
          buttonColor={buttonColor?.color || defaultButtonColor}
          buttonTextColor={buttonTextColor?.color || defaultButtonTextColor}
          aria-label={translations?.accessibility?.openFeedbackForm || 'Open feedback form'}
        />
      )}
    </>
  );
};

export default TypeForm;
